export default __webpack_public_path__ + "static/sales_cash_process-57010003c65c229c720f4483c8116c7e.png";